import React from 'react';

const steps = ['Select Dates', 'Contact Info', 'Review & Pay'];

export default function BookingSteps({ currentStep }) {
     return (
          <div className='flex items-center justify-center gap-2 mb-10'>
               {steps.map((label, index) => (
                    <React.Fragment key={label}>
                         <div className='flex items-center gap-2'>
                              <div
                                   className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold border-2 duration-300 ${
                                        index < currentStep
                                             ? 'bg-yellow border-yellow text-dark'
                                             : index === currentStep
                                             ? 'border-yellow text-yellow bg-yellow/10'
                                             : 'border-gray-200 text-darker/40 bg-white'
                                   }`}
                              >
                                   {index < currentStep ? '✓' : index + 1}
                              </div>
                              <span
                                   className={`hidden tablet:inline text-sm font-semibold duration-300 ${
                                        index <= currentStep
                                             ? 'text-darker'
                                             : 'text-darker/40'
                                   }`}
                              >
                                   {label}
                              </span>
                         </div>
                         {index < steps.length - 1 && (
                              <div
                                   className={`w-8 tablet:w-16 h-[2px] duration-300 ${
                                        index < currentStep ? 'bg-yellow' : 'bg-gray-200'
                                   }`}
                              />
                         )}
                    </React.Fragment>
               ))}
          </div>
     );
}
